module.exports = __webpack_public_path__ + "assets/b-icon-80.png";